<script lang="ts" module>
  export interface AuthorProps {
    name: string;
    image: string;
    eyebrow?: string;
    description: string;
  }
</script>

<script lang="ts">
  import { Section } from '@agapi/ui/section';
  import { Expandable } from '@agapi/ui/expandable';
  import { Image } from '@agapi/ui/image';
  import { css } from '@agapi/ui/panda/css';
  import { authorStyles } from './author.styles';
  import * as m from '$lib/parachute/messages';

  const { name, image, eyebrow, description }: AuthorProps = $props();

  const classes = authorStyles.raw();
</script>

<Section colorVariant="primary.vibrant" containerWidth="slim" containerStyles={classes.container}>
  <div class={css(classes.container)}>
    <Image
      src={image}
      alt={name}
      width={200}
      height={200}
      css={classes.image}
    />

    <div class={css(classes.content)}>
      <span class={css(classes.eyebrow)}>{eyebrow}</span>
      <h2 class={css(classes.name)}>{name}</h2>
      <Expandable
        showLabel={m.readMore()}
        hideLabel={m.hide()}
        fade={true}
        initialHeight={140}
        buttonVariant="secondary"
        buttonSize="xs"
      >
        <p class={css(classes.description)}>{description}</p>
      </Expandable>
    </div>
  </div>
</Section>
